var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterBefore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 65,
    viewBox: "0 0 1440 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_1385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.739 30.4857H4C1.79086 30.4857 0 32.2765 0 34.4857V192.503C0 194.711 1.78917 196.501 3.99722 196.503L1436 197.497C1438.21 197.499 1440 195.707 1440 193.497V30.8991C1440 28.69 1438.21 26.8991 1436 26.8991H1347.06C1346.27 26.8991 1345.5 26.6654 1344.85 26.2273L1343.26 25.1732C1341.65 24.0969 1339.5 24.3344 1338.15 25.7365L1323.83 40.7152C1322.18 42.4347 1319.41 42.3469 1317.88 40.5269L1307.6 28.3226C1306.84 27.4201 1305.72 26.8991 1304.54 26.8991H1144.93C1143.84 26.8991 1142.79 27.3508 1142.03 28.1481L1128.26 42.6862C1127.5 43.4836 1126.45 43.9352 1125.35 43.9352H1056.06C1055.03 43.9352 1054.03 43.5316 1053.28 42.8097L1027.81 18.1617C1027.07 17.4397 1026.07 17.0361 1025.03 17.0361H946.181C944.91 17.0361 943.714 16.4321 942.96 15.4089L934.366 3.74489C932.914 1.77422 930.048 1.55836 928.317 3.28926L902.292 29.3141C901.542 30.0643 900.525 30.4857 899.464 30.4857H386.314C385.254 30.4857 384.236 30.9071 383.486 31.6573L366.899 48.2439C365.323 49.82 362.763 49.8038 361.207 48.2079L330.243 16.4504C329.491 15.6783 328.458 15.2428 327.379 15.2428H296.799C295.651 15.2428 294.559 15.7358 293.799 16.5964L282.738 29.1322C281.979 29.9927 280.887 30.4857 279.739 30.4857Z",
    fill: "#E9ABE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_1385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBefore);
export default __webpack_public_path__ + "static/media/footer-before.884eb2526d196b86af5c7ab3ce342776.svg";
export { ForwardRef as ReactComponent };